






































































import { defineComponent, reactive, watch } from "@vue/composition-api";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue from "vue";

export default defineComponent({
  name: "WysiwygEditor",
  components: { FontAwesomeIcon },
  props: ["value"],
  setup(p, c) {
    watch(
      () => p.value,
      (v) => Vue.set(state, "innerValue", v)
    );
    watch(
      () => p.value,
      (v) => console.log("WysiwygEditor", v),
      { deep: true }
    );
    const state = reactive({
      innerValue: p.value,
      onInput: (e: any) => c.emit("editorUpdate", e.target.innerHTML),
      applyBold: () => document.execCommand("bold"),
      applyItalic: () => document.execCommand("italic"),
      applyHeading: () => document.execCommand("formatBlock", false, "<h2>"),
      justifyLeft: () => document.execCommand("justifyLeft"),
      justifyCenter: () => document.execCommand("justifyCenter"),
      justifyRight: () => document.execCommand("justifyRight"),
      justifyFull: () => document.execCommand("justifyFull"),
      clearFormatting: () => document.execCommand("formatBlock", false, ""),
      applyUl: () => document.execCommand("insertUnorderedList"),
      applyOl: () => document.execCommand("insertOrderedList"),
      insertHorizontalRule: () => document.execCommand("insertHorizontalRule"),
      undo: () => document.execCommand("undo"),
      redo: () => document.execCommand("redo"),
      displayUrlPrompt: false,
      focusElement: {} as HTMLElement | undefined,
      link: function click() {
        const sText = window.document.getSelection();
        const url = prompt("Enter URL", "");
        document.execCommand(
          "insertHTML",
          false,
          '<a class="text-blue-800 font-bold underline" href="' +
            url +
            '" target="_blank">' +
            sText +
            "</a>"
        );
      },
    });
    return state;
  },
});
